<div class="inventoryitem">
    <button @click="viewItem" :class="{unviewed: !viewed}">
        <span class="title">{{ title }}</span>
        <span v-if="type === 'image'" class="content image" :style="backgroundImage" ></span>
        <span v-if="type === 'letter'" class="content letter" v-html="decodedContent"></span>
    </button>
</div>
